var UtilCompatibility = /** @class */ (function () {
    function UtilCompatibility() {
        this.getMsGridPositions = function (itemNumber, columns) {
            var column = (itemNumber % columns) + 1;
            var row = Math.floor(itemNumber / columns) + 1;
            return {
                gridColumnStart: column,
                gridRowStart: row,
                msGridColumn: column,
                msGridRow: row,
            };
        };
    }
    return UtilCompatibility;
}());
export var utilCompatibility = new UtilCompatibility();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilCompatibility.ts
// module id = 355
// module chunks = 3